import { getHoursAndMinutes } from '../../../../../utils/helpers';
import './TotalItem.module.scss';

export default function TotalItem({ item, value, rateType, sx }) {
  return (
    <div className="text-lg text-navy-blue" style={sx}>
      <p className="flex gap-2">
        <span className="font-normal">{item}:</span>
        <span className="font-semibold">
          {rateType === 'hourly' ? getHoursAndMinutes(value) : `${parseFloat(value.toFixed(2).toString())} d`}
        </span>
      </p>
    </div>
  );
}
